var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCorrectReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#E4F8F0",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1225_59614",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1225_59614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.352 34.5L27.827 30.95L29.227 29.55L31.352 31.675L35.602 27.425L37.002 28.85L31.352 34.5ZM16.002 36.5V18.5C16.002 17.95 16.1978 17.4792 16.5895 17.0875C16.9811 16.6958 17.452 16.5 18.002 16.5H34.002C34.552 16.5 35.0228 16.6958 35.4145 17.0875C35.8061 17.4792 36.002 17.95 36.002 18.5V25.5H34.002V18.5H18.002V31.625L19.152 30.5H26.002V32.5H20.002L16.002 36.5Z",
    fill: "#1EA97C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrectReport);
export default __webpack_public_path__ + "static/media/icon_correct_report.247af09cfba6774ccaea8ea76f36db1b.svg";
export { ForwardRef as ReactComponent };